// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDq36rHx_Z1Q0W5EZJF_nGCejcI11Kh8Tc",
  authDomain: "health-care-hospital-26fd8.firebaseapp.com",
  projectId: "health-care-hospital-26fd8",
  storageBucket: "health-care-hospital-26fd8.appspot.com",
  messagingSenderId: "988868075766",
  appId: "1:988868075766:web:1c41026491cc8c3dd10cd7",
};

export default firebaseConfig;
